import { useQuery as useApolloQuery } from '@apollo/client'

import { client } from '@root/apollo-client-csr'

export const useQuery = (query, options) => {
  return useApolloQuery(query, { ...options, client, errorPolicy: 'all' })
}
